import React, { createContext, useState } from 'react';



const ServiceContext = createContext();


const ServiceProvider = ({ children }) => {
  const [serviceId, setServiceId] = useState(null);



  return (
    <ServiceContext.Provider value={{ serviceId, setServiceId }}>
      {children}
    </ServiceContext.Provider>
  );
};

export { ServiceContext, ServiceProvider };